import { format, parseISO, formatDistance, formatDistanceToNow } from 'date-fns';
import { ru } from 'date-fns/locale';

const LOCALE = { locale: ru };

export const DEFAULT_FORMAT = 'yyyy-MM-dd HH:mm';
export const DEFAULT_WITHOUT_TIME_FORMAT = 'yyyy-MM-dd';

const ISO_TIME_LETTER = 'T';

// ДАТА --> ЛОКАЛЬНАЯ ДАТА
export const localeDate = (date) => date && new Date(`${date}Z`);

// ФОРМАТИРОВАНИЕ ПОД СТАНДАРТНЫЙ ФОРМАТ (такой же принимает и отдает сервер)
export const defaultFormat = (date, formatstring = DEFAULT_FORMAT) => date && format(new Date(date), formatstring);

// ВРЕМЯ СЕРВЕРА --> ЛОКАЛЬНОЕ ВРЕМЯ С ФОРМАТИРОВАНИЕМ
export const localeFormat = (value, formatstring = 'dd.MM.yyyy (HH:mm)') => value && format(parseISO(`${value}Z`), formatstring, LOCALE);

export const localeFormatDistance = (value, val2, opt) => value && formatDistance(value, val2, { ...opt, ...LOCALE });

// ВРЕМЯ СЕРВЕРА --> ЛОКАЛЬНОЕ ВРЕМЯ С ФОРМАТИРОВАНИЕМ, КАК У СЕРВЕРА
export const localeFormatDefault = (value) => value && localeFormat(value, DEFAULT_FORMAT);

// ЛОКАЛЬНОЕ ВРЕМЯ --> ВРЕМЯ СЕРВЕРА (по Гринвичу)
export const serverDate = (value, removeTimeZone = false) => value && value.toISOString().slice(0, removeTimeZone ? -1 : 0);

// ЛОКАЛЬНОЕ ВРЕМЯ --> ДАТА СЕРВЕРА (по Гринвичу без времени в формате YYYY-MM-DD)
export const serverDateWithoutTime = (value) => value && value.toISOString().split(ISO_TIME_LETTER).shift();

// ЛОКАЛЬНОЕ ВРЕМЯ --> ВРЕМЯ СЕРВЕРА (по Гринвичу) с удалением `Z` на конце и форматированием
export const serverDateDefault = (date) => defaultFormat(serverDate(new Date(date), true));

export default {
  install(Vue) {
    Vue.prototype.$dateprint = {
      localeDate,
      defaultFormat,
      localeFormatDefault,
      localeFormatDistance,
      serverDate,
      serverDateWithoutTime,
      localeFormat,
      formatDistanceToNow,
      serverDateDefault,
    };
  },
};

/**
 * От НИКИТЫ получил ещё такое, но пока не знаю, где использовать

import {
  formatRelative, format, parseISO,
  formatDistanceToNow,
  formatDistanceToNowStrict,
} from 'date-fns';
import { ru } from 'date-fns/locale';

const formatRelativeLocale = {
  lastWeek: 'dd MMMM - cccc',
  yesterday: "'Вчера'",
  today: "'Сегодня'",
  tomorrow: "'Завтра'",
  nextWeek: "'На следующей неделе' - eeee",
  other: 'dd.MM.yyyy',
};

const RELATIVE_LOCALE = {
  ...ru,
  formatRelative: (token) => formatRelativeLocale[token],
};

// Добавить минуты
export const dateprintAdd = (value, duration) => add(parseISO(value), { minutes: duration });

export const dateprintRelative = (date, dateFrom) => formatRelative(
  parseISO(date), dateFrom, { locale: RELATIVE_LOCALE },
);
export const dateprintFormatDistanceToNow = (
  value,
) => formatDistanceToNowStrict(parseISO(`${value}Z`), { locale: ru, addSuffix: true });

 */
